<template>
  <div class="orgGuide">
      <!-- 机构使用指南 -->
      <div  class="swiper">
            <el-collapse v-model="activeName" accordion @change="mainChange">
                <el-collapse-item title="如何创建子账号？" name="1">
                <div>
                        <p class="remind" v-if="indexOne == 0">第一步：点击“创建子账号”按钮</p>
                        <p class="remind" v-if="indexOne == 1">第二步：输入用户名,如“测试2”</p>
                        <p class="remind" v-if="indexOne == 2">第三步：输入账号密码（选填）</p>
                        <p class="remind" v-if="indexOne == 3">第四步：点击输入框输入分配文件上传次数或点击“+”“-”来分配文件上传次数</p>
                        <p class="remind" v-if="indexOne == 4">第五步：点击“确认”按钮创建子账号</p>
                    </div>
                    <div class="main1">
                        <div class="tdesign-demo-block--swiper-new" >
                            <!-- :style="{ width: '700px',height:'500px' }" -->
                            <t-swiper :navigation="{ placement: 'outside' }" @change="changeOne">
                                <t-swiper-item v-for="(item,index) in srcList " :key="'info1-'+index">
                                    <div class="warp">
                                        <el-image class="img" :src="item" 
                                        :preview-src-list="srcList"></el-image>
                                    </div>
                                </t-swiper-item>
                            </t-swiper> 
                        </div>
                    </div>
                </el-collapse-item>
                <el-collapse-item title="如何批量禁用个人账号？" name="2">
                    <div>
                        <p class="remind" v-if="indexTwo == 0">第一步：勾选你要禁用的账号</p>
                        <p class="remind" v-if="indexTwo == 1">第二步：点击“批量禁用”按钮禁用个人账号</p>
                    </div>
                    <!-- changeTwo -->
                    <div class="main1">
                        <div class="tdesign-demo-block--swiper-new" >
                            <!-- :style="{ width: '700px',height:'500px' }" -->
                            <t-swiper :navigation="{ placement: 'outside' }" @change="changeTwo">
                                <t-swiper-item v-for="(item,index) in srcImg " :key="'info2-'+index">
                                    <div class="warp">
                                        <el-image class="img" :src="item" 
                                        :preview-src-list="srcImg"></el-image>
                                    </div>
                                </t-swiper-item>
                            </t-swiper> 
                        </div>
                    </div>
                </el-collapse-item>
                <el-collapse-item title="如何批量删除个人账号？" name="3">
                <div>
                        <p class="remind" v-if="indexThree == 0">第一步：勾选你要删除的账号</p>
                        <p class="remind" v-if="indexThree == 1">第二步：点击“批量删除”按钮删除个人账号</p>
                    </div>
                    <div class="main1">
                        <div class="tdesign-demo-block--swiper-new" >
                            <!-- :style="{ width: '700px',height:'500px' }" -->
                            <t-swiper :navigation="{ placement: 'outside' }" @change="changeThree">
                                <t-swiper-item v-for="(item,index) in srcThree " :key="'info3-'+index">
                                    <div class="warp">
                                        <el-image class="img" :src="item" 
                                        :preview-src-list="srcThree"></el-image>
                                    </div>
                                </t-swiper-item>
                            </t-swiper> 
                        </div>
                    </div>
                </el-collapse-item>
                <el-collapse-item title="如何批量重置个人账号密码？" name="4">
                    <div>
                        <p class="remind" v-if="indexfour == 0">第一步：勾选你要重置密码的账号</p>
                        <p class="remind" v-if="indexfour == 1">第二步：点击“批量密码重置”按钮重置个人账号密码</p>
                    </div>
                    <div class="main1">
                        <div class="tdesign-demo-block--swiper-new" >
                            <!-- :style="{ width: '700px',height:'500px' }" -->
                            <t-swiper :navigation="{ placement: 'outside' }" @change="changefour">
                                <t-swiper-item v-for="(item,index) in srcFour " :key="'info4-'+index">
                                    <div class="warp">
                                        <el-image class="img" :src="item" 
                                        :preview-src-list="srcFour"></el-image>
                                    </div>
                                </t-swiper-item>
                            </t-swiper> 
                        </div>
                    </div>
                </el-collapse-item>
                <el-collapse-item title="如何批量启用被禁用的个人账号？" name="5">
                    <div>
                        <p class="remind" v-if="indexfive == 0">第一步：勾选你要批量启用的账号</p>
                        <p class="remind" v-if="indexfive == 1">第二步：点击“启用”按钮启用被禁用的个人账号</p>
                    </div>
                    <div class="main1">
                        <div class="tdesign-demo-block--swiper-new" >
                            <!-- :style="{ width: '700px',height:'500px' }" -->
                            <t-swiper :navigation="{ placement: 'outside' }" @change="changefive">
                                <t-swiper-item v-for="(item,index) in srcFive " :key="'info5-'+index">
                                    <div class="warp">
                                        <el-image class="img" :src="item" 
                                        :preview-src-list="srcFive"></el-image>
                                    </div>
                                </t-swiper-item>
                            </t-swiper> 
                        </div>
                    </div>
                </el-collapse-item>
                <el-collapse-item title="如何退出机构账号登录？" name="6">
                    <div>
                        <p class="remind" v-if="indexsix == 0">第一步：点击账号头像</p>
                        <p class="remind" v-if="indexsix == 1">第二步：点击”退出登录“选项退出登录</p>
                    </div>
                    <div class="main1">
                        <div class="tdesign-demo-block--swiper-new" >
                            <!-- :style="{ width: '700px',height:'500px' }" -->
                            <t-swiper :navigation="{ placement: 'outside' }" @change="changesix">
                                <t-swiper-item v-for="(item,index) in srcsix " :key="'info5-'+index">
                                    <div class="warp">
                                        <el-image class="img" :src="item" 
                                        :preview-src-list="srcsix"></el-image>
                                    </div>
                                </t-swiper-item>
                            </t-swiper> 
                        </div>
                    </div>
                </el-collapse-item>
                <el-collapse-item title="被删除的账号还能重新启用吗？" name="7">
                    <div>
                        <p class="remind">不可以，被删除的账号已经被注销了，无法重新启用，如需再次使用需要重新创建子账号</p>
                    </div>
                </el-collapse-item>
            </el-collapse>
          
      </div>
  </div>
</template>

<script>
export default {
    name:"orgGuide",
    data(){
        return{
            indexOne:0,//如何上传需要切分处理的PDF文件？
            indexTwo:0,//如何查询PDF文件处理进度？
            indexThree:0,//如何修改账号密码?
            indexfour:0,//如何退出账号登录？
            indexfive:0,
            indexsix:0,
            activeName: '',// 默认展开
            role:localStorage.getItem("role"),
            srcList: [require('../../assets/org/1-1.png'),require('../../assets/org/1-2.png'),require('../../assets/org/1-3.png'),require('../../assets/org/1-5.png'),require('../../assets/org/1-6.png')],
            srcImg: [require('../../assets/org/1.png'),require('../../assets/org/禁用.png')],
            srcThree:[require('../../assets/org/1.png'),require('../../assets/org/删除.png')],
            srcFour:[require('../../assets/org/1.png'),require('../../assets/org/重置密码.png')],
            srcFive:[require('../../assets/org/1.png'),require('../../assets/org/启用.png')],
            srcsix:[require('../../assets/org/退出登录.png'),require('../../assets/org/退出登录-2.png')]
        }
    },
    methods: {
        changeOne(current,context){
            this.indexOne = current
        },
        changeTwo(current,context){
            this.indexTwo = current
        },
        changeThree(current,context){
            this.indexThree = current
        },
        changefour(current,context){
            this.indexfour = current
        },
        changefive(current,context){
            this.indexfive = current
        },
        changesix(current,context){
            this.indexsix = current
        },
        mainChange(activeNames){
            console.log(activeNames)
            if(activeNames == 1){
                this.indexOne = 0
            }else if(activeNames == 2){
                this.indexTwo = 0
            }else if(activeNames == 3){
                this.indexThree = 0
            }else if(activeNames == 4){
                this.indexfour = 0
            }else if(activeNames == 5){
                this.indexfive = 0
            }else if(activeNames == 5){
                this.indexsix = 0
            }
        }
        
    },
}
</script>
<style>
.el-image-viewer__wrapper {
    position: fixed;
    top: 0;
    right: 0;
    bottom: 0;
    left: 0;
    padding: 5%;
}
.main1{
    width: 90%;
    margin: auto;
}
</style>
<style lang="scss" scoped>
::v-deep .el-collapse-item__header {
    display: flex;
    align-items: center;
    height: 48px;
    line-height: 48px;
    background-color: #FFF;
    cursor: pointer;
    border-bottom: 1px solid #EBEEF5;
    font-size: 18px;
    color: #333;
    transition: border-bottom-color .3s;
    outline: 0;
    padding-left: 20px;
}
.bold{
    font-size: 16px;
    font-weight: bold;
}
::v-deep .t-swiper__arrow--default .t-swiper__arrow-left {
    position: absolute;
    top: 50%;
    transform: translateY(-50%);
    display: flex;
    width: 24px;
    height: 24px;
    justify-content: center;
    align-items: center;
    z-index: 2;
    background-color: rgba(130, 128, 128, 0);
    border: 1px solid ;
    color: rgb(0 0 0 / 55%);
    cursor: pointer;
    left: 16px;
}
::v-deep .t-swiper__arrow--default .t-swiper__arrow-right {
    position: absolute;
    top: 50%;
    border: 1px solid ;
    transform: translateY(-50%);
    display: flex;
    width: 24px;
    height: 24px;
    justify-content: center;
    align-items: center;
    z-index: 2;
    background-color: rgba(130, 128, 128, 0);
    color: rgb(0 0 0 / 55%);
    cursor: pointer;
    right: 16px;
}
::v-deep .t-swiper__arrow-left{
    width: 35px !important;
    height: 35px !important;
    border-radius: 50% !important;
}
::v-deep .t-swiper__arrow-right{
    width: 35px !important;
    height: 35px !important;
    border-radius: 50% !important;
}
.remind{
    margin-bottom: 20px;
    font-size: 16px;
    font-weight: 700;
    margin-left:30px;
    margin-top: 10px;
    color: rgb(243, 9, 9);
}
.warp{
    position: relative;
    background: rgba(0,0,0,.5);
    width: 100%;
    height: 650px;
}
.guide{
    padding:20px;
    background-color: white;
    // min-height: 1000px;
}
.t-swiper {
    // position: relative;
    // width: 100%;
    // height: 700px;
}
.img{
    background-size: 100% 100%;
    position: absolute;
    top: 0;
    bottom: 0;
    left: 0;
    right: 0;
}
</style>